import React from 'react';
import { Wrapper } from '@magoosh/gre/adaptive_prep_v1/lib/wrapper';
import { PageCard } from '@magoosh/gre/adaptive_prep_v1/lib/page_card';
import { UserProvider } from '@magoosh/context/user_context';
import { YourClassesProvider } from '@magoosh/pages/live_classes/all_classes/context';
import { YourClasses } from '@magoosh/pages/live_classes/your_classes/organisms/your_classes';

interface Props {
  descriptionHtml: string;
}

export const YourClassesPage: React.FC<Props> = (props) => {
  return (
    <Wrapper>
      <PageCard>
        <UserProvider>
          <YourClassesProvider>
            <YourClasses {...props} />
          </YourClassesProvider>
        </UserProvider>
      </PageCard>
    </Wrapper>
  );
};

export default YourClassesPage;
